// src/App.js
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";

import Login from "./components/login/Login";
import Dashboard from "./components/login/Dashboard";
import { decryptData } from "./utils/encrypt";
import PrivateRoute from "./config/PrivateRoute";

// Component Imports
import OrganizationForm from "./components/organization/OrganizationForm";
import OrganizationSearch from "./components/organization/OrganizationSearch";
import UserForm from "./components/user/UserForm";
import UserSearch from "./components/user/UserSearch";
import UserProfileManagement from "./components/user/UserProfileManagement";

import AccountNew from "./components/account/AccountNew";
import AccountSearch from "./components/account/AccountSearch";
import AccountView from "./components/account/AccountView";
import AccountEdit from "./components/account/AccountEdit";
import AccountAccess from "./components/account/AccountAccess";
import WabaAssignment from './components/account/WabaAssignment';

import AccountAccessRefresh from './components/account/AccountAccessRefresh'; // adjust path as needed
import DispatchPendingReport from "./components/so/DispatchPendingReport";


import SalesOrderNew from "./components/so/SalesOrderNew";
import SalesOrderSearch from "./components/so/SalesOrderSearch";

import SalesOrderPlanningSearch from "./components/soplanning/SalesOrderPlanningSerch";
import SalesOrderPlanningNew from "./components/soplanning/SalesOrderPlanningNew";
import EditDispatch from "./components/soplanning/EditDispatch";

import DispatchPlanning from "./components/dispatchplanning/DispatchPlanning";

import SalesInvoiceSearch from "./components/salesinvoice/SalesInvoiceSearch";
import SalesInvoiceNew from "./components/salesinvoice/SalesInvoiceNew";
import SalesInvoiceView from "./components/salesinvoice/SalesInvoiceView";

import SOPlanningClose from "./components/soplanning/SOPlanningClose";

import TransportNew from "./components/transport/TransportNew";
import TransportSearch from "./components/transport/TransportSearch";

import ProductionSearch from "./components/production/ProductionSearch";
import ProductionNew from "./components/production/ProductionNew";
import LoadingPointNew from "./components/production/LoadingPointNew";

import StockReport from './components/stockreport/StockReport';

import EditPlanning from "./components/soplanning/EditPlanning";
import EditPlanningDetail from "./components/soplanning/EditPlanningDetail";
import LogisticPlanning from "./components/logistics/LogisticPlanning";

import SoPlanDispatchReport from "./components/so/SoPlanDispatchReport";

import CreditNoteNew from "./components/creditnote/CreditNoteNew";
import CreditNoteReport from "./components/creditnote/CreditNoteReport";
import InvoiceReport from "./components/creditnote/InvoiceReport";

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [checkingLogin, setCheckingLogin] = useState(true);

  useEffect(() => {
    const encrypted = localStorage.getItem("suyog_user");
    if (encrypted) {
      try {
        const user = decryptData(encrypted);
        if (user.user_id && user.user_name) {
          setLoggedIn(true);
        }
      } catch {
        setLoggedIn(false);
      }
    }
    setCheckingLogin(false);
  }, []);

  if (checkingLogin) return <div className="text-center mt-5">Loading...</div>;

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            loggedIn ? (
              <Navigate to="/dashboard" />
            ) : (
              <Login onLoginSuccess={() => setLoggedIn(true)} />
            )
          }
        />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <Dashboard
                onLogout={() => {
                  localStorage.removeItem("suyog_user");
                  setLoggedIn(false);
                }}
              />
            </PrivateRoute>
          }
        />


<Route
          path="/logistics/planning"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <LogisticPlanning />
            </PrivateRoute>
          }
        />




        <Route
          path="/organization/add"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <OrganizationForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/organization/search"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <OrganizationSearch />
            </PrivateRoute>
          }
        />

        <Route
          path="/user/new"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <UserForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/user/search"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <UserSearch />
            </PrivateRoute>
          }
        />
        <Route
          path="/user/profile/:id/:user_id/:user_token"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <UserProfileManagement />
            </PrivateRoute>
          }
        />

        <Route
          path="/account/new"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <AccountNew />
            </PrivateRoute>
          }
        />
        <Route
          path="/account/search"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <AccountSearch />
            </PrivateRoute>
          }
        />


 <Route
          path="/account/waba-assignment"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <WabaAssignment  />
            </PrivateRoute>
          }
        />



        <Route
          path="/account/view/:id/:token"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <AccountView />
            </PrivateRoute>
          }
        />
        <Route
          path="/account/edit/:id/:token"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <AccountEdit />
            </PrivateRoute>
          }
        />
        <Route
          path="/account/access"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <AccountAccess />
            </PrivateRoute>
          }
        />

         <Route
  path="/account/access_refresh"
  element={
    <PrivateRoute loggedIn={loggedIn}>
      <AccountAccessRefresh />
    </PrivateRoute>
  }
/>


        <Route
          path="/so/new"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <SalesOrderNew />
            </PrivateRoute>
          }
        />
        <Route
          path="/so/search"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <SalesOrderSearch />
            </PrivateRoute>
          }
        />

        <Route
          path="/soplanning/search"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <SalesOrderPlanningSearch />
            </PrivateRoute>
          }
        />


        <Route
  path="/so/so-plan-dispatch"
  element={
    <PrivateRoute loggedIn={loggedIn}>
      <SoPlanDispatchReport />
    </PrivateRoute>
  }
/>

        <Route
          path="/soplanning/setvehicle"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <SalesOrderPlanningSearch />
            </PrivateRoute>
          }
        />
        <Route
          path="/soplanning/new"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <SalesOrderPlanningNew />
            </PrivateRoute>
          }
        />


          <Route
          path="/planning/edit"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <EditPlanning  />
            </PrivateRoute>
          }
        />


         <Route
          path="/planning/plan/:planningId"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <EditPlanningDetail   />
            </PrivateRoute>
          }
        />


        <Route
          path="/soplanning/close"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <SOPlanningClose />
            </PrivateRoute>
          }
        />

        <Route
  path="/dispatch/report/pending"
  element={
    <PrivateRoute loggedIn={loggedIn}>
      <DispatchPendingReport />
    </PrivateRoute>
  }
/>

        <Route
          path="/dispatchplanning"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <DispatchPlanning />
            </PrivateRoute>
          }
        />
        <Route
          path="/edit-dispatch"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <EditDispatch />
            </PrivateRoute>
          }
        />

        <Route
          path="/salesinvoice/search"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <SalesInvoiceSearch />
            </PrivateRoute>
          }
        />
        <Route
          path="/salesinvoice/new"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <SalesInvoiceNew />
            </PrivateRoute>
          }
        />



         <Route
          path="/creditnote/creditnotenew"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <CreditNoteNew />
            </PrivateRoute>
          }
        />


         <Route
          path="/creditnote/creditnotereport"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <CreditNoteReport />
            </PrivateRoute>
          }
        />

  <Route
          path="/creditnote/invoicereport"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <InvoiceReport />
            </PrivateRoute>
          }
        />


        <Route
          path="/salesinvoice/view"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <SalesInvoiceView />
            </PrivateRoute>
          }
        />

        <Route
          path="/transport/search"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <TransportSearch />
            </PrivateRoute>
          }
        />
        <Route
          path="/transport/new"
          element={
            <PrivateRoute loggedIn={loggedIn}>
              <TransportNew />
            </PrivateRoute>
          }
        />

        <Route path="/production/search" element={<ProductionSearch />} />
        <Route path="/production/new" element={<ProductionNew />} />
        <Route path="/production/loadingpointnew" element={<LoadingPointNew />} />
        <Route path="/stockreport/stock" element={
        
            <PrivateRoute loggedIn={loggedIn}>
                <StockReport />
            </PrivateRoute>
          
          
          } />



        <Route
          path="/"
          element={<Navigate to={loggedIn ? "/dashboard" : "/login"} />}
        />
        <Route
          path="*"
          element={<Navigate to={loggedIn ? "/dashboard" : "/login"} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
